import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'

export default function Volunteers () {
  const { t } = useTranslation('race')
  return (
    <Container maxWidth='xl'>
      <Typography
        variant='h5' gutterBottom sx={{
        fontWeight: 'bold'
      }}
      >
        {t('volunteers.title')}
      </Typography>
      <Typography variant='body1'>
        {t('volunteers.p1')}
      </Typography><br />
      <Typography variant='body1'>
        {t('volunteers.p2')}
      </Typography><br />
      <Typography variant='body1'>
        {t('volunteers.p3')}
      </Typography><br />
      <Button
        component={Link}
        target='_blank'
        href='https://chat.whatsapp.com/KeyDv14ynfg8SIcHyyDfde'
        startIcon={<WhatsAppIcon />}
        variant='outlined'
        sx={{ color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
      >
        {t('volunteers.whatsappGroup')}
      </Button>
    </Container>
  )
}
